module.exports = __webpack_public_path__ + "img/热销榜单.f3ae05ac.png";